import React, { useState, useEffect, useContext } from "react";

import cn from "classnames";
import "./style.scss";
import Layout from "./components/Layout";
import bgMain from "./img/bg.jpg";
import bgStep from "./img/bgstep.jpg";
import firstImg from "./img/giphy.gif";
import Header from "./components/Header";
import Popup from "./components/Popup";
import BodyQuiz from "./components/BodyQuiz";
import Title from "./components/Title";
import BoxContent from "./components/BoxContent";
import Content from "./components/Content";
import Button from "./components/Button";
import ProgressBar from "./components/ProgressBar";
import CheckboxContainer from "./components/CheckboxContainer";
import Label from "./components/Label";
import Checkbox from "./components/Checkbox";
import DoneProgress from "./components/DoneProgress";
import Input from "./components/Input";
import Footer from "./components/Footer";
import ErrorField from "./components/ErrorField";
import Cookies from "./components/Cookies";
import FooterMenu from "./components/FooterMenu";
import LoaderEmail from "./components/LoaderEmail";

import SelectGlobal from "./components/SelectGlobal";

import { apiRegistration } from "./services/api";
import { ContextProfileUser } from "./lib/profileContext";
import {
  CONST_GENDER_MALE,
  TEXT_GENDER_MALE,
  CONST_GENDER_FEMALE,
  TEXT_GENDER_FEMALE,
  COOKIE_QUERY_NAME,
  COOKIE_NAME,
  REGISTRATION_CONFIRMED,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  validateName,
  validateEmail,
  getMonths,
  getYears,
  getDate,
  validateAge,
  getBirthdayInFormat,
  getMonthsByIndex,
  validatePassword,
  deleteCookie,
  gtmRegistration,
  prepareRegistrationData,
  simplyClick,
  hasCookiebotDialog,
  hasConsented,
  sendScreenResolution,
  toggleStorage,
} from "./helpers";
import {
  errorEventsBirthday,
  errorEventsEmail,
  errorEventsName,
  errorEventsPassword,
  events,
  IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
  ERROR_EMAIL_ALREADY_USED,
  InterestedIn,
  Lifestyle,
  AppreciatePeople,
  landingId,
  Question7,
} from "./constants";
import CustomEmailAutoComplete from "./components/CustomEmailAutoComplete";
import Tooltip from "./components/Tooltip";
import { useWizardAnswers, useSessionData } from "ui-components";

const App = () => {
  const [startQuiz, setStartQuiz] = useState(false);
  const [background, setBackground] = useState(bgMain);
  const [step, setStep] = useState(0);
  const [errorName, setErrorName] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(null);
  const [errorCheckbox, setErrorCheckbox] = useState(false);
  const [errorBirthday, setErrorBirthday] = useState(null);
  const [responseError, setResponseError] = useState(null);
  const [cookiesState, setCookiesState] = useState(true);
  const updateAnswer = useWizardAnswers();
  const [isOpenMonth, setIsOpenMonth] = useState(false);
  const [isOpenDay, setIsOpenDay] = useState(false);
  const [isOpenYears, setIsOpenYears] = useState(false);
  const [selectionMonth, setSelectionMonth] = useState(null);
  const [selectionDay, setSelectionDay] = useState(null);
  const [selectionYears, setSelectionYears] = useState(null);
  const [cursor, setCursor] = useState(0);
  const [x, setX] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [loader, setLoader] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");
  const [password, setPassword] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const partnersData = 84397;
  const maxPartners = 100000;
  const matchData = 93;
  const maxMatch = 100;

  const allMonths = getMonthsByIndex();

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useEffect(() => {
    sendScreenResolution();

    const timer = setTimeout(async () => {
      if (!hasConsented() && !hasCookiebotDialog()) {
        setCookiesState(false);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".btn--sign");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton?.setAttribute("href", `/login${lndId}`);
    }

    const termsLinks = document.querySelectorAll(".footer-menu a");
    termsLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (href && !href.startsWith("mailto:")) {
        link.setAttribute("href", `${href}${lndId}`);
      }
    });
  }, []);

  useEffect(() => {
    const loginButton = document.querySelector(".btn--sign");

    const clickHandler = () => {
      simplyClick(events[step + 1]);
    };

    loginButton.addEventListener("click", clickHandler);

    return () => {
      loginButton.removeEventListener("click", clickHandler);
    };
  }, [step]);

  const soldCheckbox = () => {
    setX(!x);
    simplyClick("cl_lnd_cd4_password_checkbox_mark", null);
  };
  useEffect(() => {
    setSelectedOptions([]);
  }, [step]);

  const handleQuestionChange = (step, newSelected) => {
    const eventMap = {
      6: "cl_lnd_cd4_fifth_ques_choose",
      7: "cl_lnd_cd4_sixth_ques_choose",
      8: "cl_lnd_cd4_sev_ques_choose",
    };

    const eventName = eventMap[step];
    if (eventName) {
      simplyClick(eventName, { text: newSelected.join(", ") });
    }
  };

  const handleCheckboxChange = (value) => {
    let updatedOptions = [...selectedOptions];
    if (updatedOptions.includes(value)) {
      updatedOptions = updatedOptions.filter((v) => v !== value);
    } else {
      updatedOptions.push(value);
    }

    setSelectedOptions(updatedOptions);
    handleQuestionChange(step, updatedOptions);
  };
  const cookiesHandler = () => {
    setCookiesState(true);
    toggleStorage(true);
  };
  const handleAddMonth = (e) => {
    setErrorBirthday(null);
    setData({ ...data, month: e.target.value });
    simplyClick("cl_lnd_cd4_date_birth_month_choose");
  };

  const handleAddDay = (e) => {
    setErrorBirthday(null);
    setData({ ...data, day: e.target.value });
    simplyClick("cl_lnd_cd4_date_birth_day_choose");
  };

  const handleAddYear = (e) => {
    setErrorBirthday(null);
    setData({ ...data, year: e.target.value });
    simplyClick("cl_lnd_cd4_date_birth_year_choose");
  };
  const handleKeyPress = (e) => {
    if (!isOpenMonth) return;
    if (!isOpenDay) return;
    if (!isOpenYears) return;

    if (e.key === "ArrowUp") {
      // Jump to last option after reaching top
      if (cursor === 0) {
        setCursor(getMonths().length - 1);
        setCursor(getDate().length - 1);
        setCursor(getYears().length - 1);
      } else {
        setCursor(cursor - 1);
      }
    }

    if (e.key === "ArrowDown") {
      // Jump to first option after reaching the bottom
      if (
        cursor === getDate.length - 1 ||
        cursor === getMonths().length ||
        cursor === getYears.length
      ) {
        setCursor(0);
      } else {
        setCursor(cursor + 1);
      }
    }

    if (e.key === "Enter") {
      setSelectionMonth(getMonths[cursor]);
      setSelectionDay(getDate[cursor]);
      setSelectionYears(getYears[cursor]);
    }

    if (e.key === "Escape") {
      setIsOpenMonth(false);
      setIsOpenDay(false);
      setIsOpenYears(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return function cleanUp() {
      window.removeEventListener("keydown", handleKeyPress);
    };
  });

  useEffect(() => {
    if (startQuiz) {
      setBackground(bgStep);
    }
  }, [startQuiz]);

  const handleChangeGender = ({ target: { value } }) => {
    const selectedGender = value;

    setData((prev) => ({
      ...prev,
      gender: selectedGender,
    }));

    simplyClick("cl_lnd_cd4_i_am_choose", { text: selectedGender });
  };

  const handlerSubmitName = () => {
    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (!status) {
      setErrorName(error.text);
    } else {
      simplyClick("cl_lnd_cd4_name_cont", {
        first_name: data?.first_name,
      });
      setStep(step + 1);
    }
  };

  const handleChangeName = ({ target: { value } }) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: value });
  };

  const handlerSubmitEmail = () => {
    setLoader(true);
    setLoaderTextMain("Checking your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still checking your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(data.email, (result) => {
      const { status, error } = result;
      setLoader(false);
      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }
      setStep(step + 1);
    });
  };

  const handleChangeEmail = ({ target: { value } }) => {
    setEmailValue(value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  const handleChangeBirthday = () => {
    const { month, day, year } = data;

    if (!month && !day && !year) {
      simplyClick("err_lnd_age_nodate");
      setErrorBirthday("Please enter your full date of birth");
      return;
    }

    const dateKey = [month ? "M" : "", day ? "D" : "", year ? "Y" : ""].join(
      ""
    );

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
      setErrorBirthday("Please enter your full date of birth");
      return;
    }

    const { status, error, errors = {} } = validateAge(month, day, year);

    // No date is entered at all
    if (!status) {
      setErrorBirthday(error);
      return;
    }

    if (errors.invalidDate) {
      setErrorBirthday(error);
      return;
    }

    const formattedBirthday = getBirthdayInFormat(year, month, day);

    setData({
      ...data,
      birthday: formattedBirthday,
    });

    simplyClick("cl_lnd_cd4_date_birth_cont", {
      birthday: formattedBirthday,
    });

    setStep(step + 1);
  };

  const isStartQuiz = () => {
    setStartQuiz(true);
    simplyClick("cl_lnd_cd4_look_for_ok");
    setStep(1);
  };

  const isViewPassword = () => {
    setPassword(!password);
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const handlerChangePassword = (e) => {
    setErrorPassword(null);
    setShowTooltip(false);
    setData({ ...data, password: e.target.value });
  };

  const postRegistrationRequest = () => {
    const { status, error = { text: "", type: "" } } = validatePassword(
      data.password
    );

    if (error.type) {
      simplyClick(errorEventsPassword[error.type]);
    }

    if (!status) {
      setErrorPassword(error.text);
      return;
    }

    if (!x) {
      simplyClick("err_lnd_checkbox_nocheckbox");
      setErrorCheckbox(true);
      return;
    }

    setLoader(true);
    apiRegistration(prepareRegistrationData(data), responseCb);
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      simplyClick("cl_lnd_cd4_password_cont");
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);

        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed === REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";

        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];

          errorText += i > 0 ? " " + error.message : error.message;
        }

        setResponseError(errorText);
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  const lndId =
    window.location.search === ""
      ? `?landing_id=${landingId}`
      : `&landing_id=${landingId}`;

  return (
    <div className="App">
      <Layout bg={background} startQuiz={startQuiz}>
        <Header />
        <ProgressBar step={step} opacity={step > 0 ? "1" : "0"} />
        <div className={`main-frame ${!startQuiz ? "main-page" : ""} `}>
          {!startQuiz && (
            <Popup>
              <BodyQuiz>
                <Title
                  text={"Find that special someone you are looking for!"}
                />
                <BoxContent gap={32}>
                  <Content
                    classname={"first"}
                    content={
                      "It seems that the beauty of our members will not leave you indifferent."
                    }
                  >
                    <img src={firstImg} alt="firstImg" />
                  </Content>
                  <Button
                    text={"ok"}
                    classname={"btn btn--primary"}
                    onClick={() => isStartQuiz()}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 1 && (
            <Popup startQuiz={startQuiz}>
              <BodyQuiz>
                <Title text={"Welcome!"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <Content
                    content={
                      "We are glad that you are here. Tell us more about yourself!"
                    }
                  />
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd4_welcome_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 2 && (
            <Popup startQuiz={startQuiz}>
              <BodyQuiz>
                <Title text={"Question 1"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <p>
                    Our members <span>enjoy</span> communicating with{" "}
                    <span>new people</span> from all over the world. Is it what
                    you are looking for?
                  </p>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Yes"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_first_ques_yes");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_first_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 3 && (
            <Popup>
              <BodyQuiz startQuiz={startQuiz}>
                <Title text={"Question 2"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <p>
                    Do you want to <span>meet charming</span> and{" "}
                    <span>open-minded</span> people?
                  </p>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Yes"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_sec_ques_yes");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_sec_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 4 && (
            <Popup startQuiz={startQuiz}>
              <BodyQuiz>
                <Title text={"Question 3"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <p>
                    Many of our members seek <span>regular communication</span>.{" "}
                    <br />
                    <nobr>Does it align with what you are looking for?</nobr>
                  </p>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Yes"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_third_ques_yes");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_third_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 5 && (
            <Popup startQuiz={startQuiz} classname={"custom-padding"}>
              <BodyQuiz>
                <Title text={"Question 4"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <p>
                    Online <span>video calls</span> are a <span>popular</span>{" "}
                    communication option for many of our members. <br />
                    Does this match your interests?
                  </p>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Yes"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_fourth_ques_yes");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_fourth_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 6 && (
            <Popup startQuiz={startQuiz}>
              <BodyQuiz>
                <Title text={"Question 5"} startQuiz={startQuiz} />
                <span className="question__options">
                  Choose up to 4 options
                </span>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content
                      content={"What do you appreciate most in people?"}
                    />
                    <div className={"ckeckbox-wrapper"}>
                      {AppreciatePeople.map((label) => (
                        <Label key={label} labelTitle={label} forId={label}>
                          <Checkbox
                            id={label}
                            checked={selectedOptions.includes(label)}
                            onChange={() => handleCheckboxChange(label)}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Next"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_fifth_ques_next");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_fifth_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 7 && (
            <Popup startQuiz={startQuiz}>
              <BodyQuiz>
                <Title text={"Question 6"} startQuiz={startQuiz} />
                <span className="question__options">
                  Choose up to 5 options
                </span>
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content
                      content={
                        "Which type of lifestyle describes you the most?"
                      }
                    />
                    <div className="ckeckbox-wrapper">
                      {Lifestyle.map((label) => (
                        <Label key={label} labelTitle={label} forId={label}>
                          <Checkbox
                            id={label}
                            checked={selectedOptions.includes(label)}
                            onChange={() => handleCheckboxChange(label)}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Next"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_sixth_ques_next", null);
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        simplyClick("cl_lnd_cd4_sixth_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 8 && (
            <Popup>
              <BodyQuiz startQuiz={startQuiz}>
                <Title text={"Question 7"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <Content content={"What are you looking for?"} />
                    <div className="ckeckbox-wrapper">
                      {Question7.map((opt) => (
                        <Label
                          key={opt.id}
                          labelTitle={opt.label}
                          forId={opt.id}
                        >
                          <Checkbox
                            id={opt.id}
                            checked={selectedOption === opt.id}
                            onChange={() => {
                              setSelectedOption(opt.id);
                              simplyClick(opt.event);
                            }}
                          />
                        </Label>
                      ))}
                    </div>
                  </CheckboxContainer>
                  <div className={"button__wrap"}>
                    <Button
                      text={"Next"}
                      classname={"btn btn--primary"}
                      onClick={() => {
                        const answerId = selectedOption || "0";
                        updateAnswer({ join_reasons: [answerId] });
                        simplyClick("cl_lnd_cd4_sev_ques_next");
                        nextStep();
                      }}
                    />
                    <Button
                      text={"Skip"}
                      classname={"btn"}
                      onClick={() => {
                        updateAnswer({ join_reasons: ["0"] });
                        simplyClick("cl_lnd_cd4_sev_ques_skip");
                        nextStep();
                      }}
                    />
                  </div>
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}

          {step === 9 && (
            <Popup startQuiz={startQuiz} classname={"popup-welldone"}>
              <BodyQuiz>
                <Title text={"Well done!"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <div className={"well-done-wrapper"}>
                    <DoneProgress
                      dataProgress={partnersData}
                      maxValue={maxPartners}
                    >
                      <div>
                        <nobr>
                          Number of <b>potential partners</b>:{" "}
                          <span>{partnersData}</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <DoneProgress dataProgress={matchData} maxValue={maxMatch}>
                      <div>
                        <nobr>
                          The probability of find a <b>match</b>:{" "}
                          <span>{matchData}%</span>
                        </nobr>
                      </div>
                    </DoneProgress>
                    <p>
                      Let's now try to <span>find the one</span> you are looking
                      for!
                    </p>
                    <Content
                      content={
                        'Click "Continue" to create an account and join our community!'
                      }
                    />
                  </div>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      simplyClick("cl_lnd_cd4_well_done_cont");
                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 10 && (
            <Popup startQuiz={startQuiz} classname={"inner-gap"}>
              <BodyQuiz>
                <Title text={"I am a"} startQuiz={startQuiz} />
                <BoxContent gap={48}>
                  <CheckboxContainer>
                    <div className={"ckeckbox-wrapper"}>
                      <Label labelTitle={"Man"} forId={"Man"}>
                        <Checkbox
                          checked={data.gender === CONST_GENDER_MALE}
                          id={"Man"}
                          type={"radio"}
                          onChange={(e) => handleChangeGender(e)}
                          value={CONST_GENDER_MALE}
                          name="gender"
                        />
                      </Label>
                      <Label labelTitle={"Woman"} forId={"Woman"}>
                        <Checkbox
                          id={"Woman"}
                          type={"radio"}
                          value={CONST_GENDER_FEMALE}
                          onChange={(e) => handleChangeGender(e)}
                          checked={data.gender === CONST_GENDER_FEMALE}
                          name="gender"
                        />
                      </Label>
                    </div>
                  </CheckboxContainer>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={() => {
                      if (!data.gender) {
                        simplyClick("cl_lnd_cd4_i_am_choose", {
                          text: CONST_GENDER_MALE,
                        });
                      }
                      simplyClick("cl_lnd_cd4_i_am_cont");

                      nextStep();
                    }}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 11 && (
            <Popup startQuiz={startQuiz} classname={"inner-gap"}>
              <BodyQuiz>
                <Title
                  text={"Enter your name or nickname"}
                  startQuiz={startQuiz}
                />
                <p className="name__text">
                  You don’t have to use your real name – feel free to use a
                  nickname. You can change it anytime.
                </p>
                <BoxContent gap={32}>
                  <CheckboxContainer className={"mail"}>
                    <Label forId="name">
                      <p>Your name</p>
                      <Input
                        typeInput={"text"}
                        onChange={handleChangeName}
                        placeholder={"Enter your name or nickname"}
                        error={errorName}
                        value={data.first_name || ""}
                        autoComplete={"name"}
                        name="name"
                        onFocus={() => {
                          setShowTooltip(true);
                          simplyClick("cl_lnd_cd4_name_type_name", null);
                        }}
                        onBlur={() => setShowTooltip(false)}
                      />
                      {errorName && <ErrorField text={errorName} />}
                      <Tooltip
                        text="Your name must contain at least 2 Latin letters. Special characters and numbers are not allowed."
                        showTooltip={showTooltip}
                      />
                    </Label>
                  </CheckboxContainer>
                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={handlerSubmitName}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 12 && (
            <Popup startQuiz={startQuiz} classname={"inner-gap"}>
              <BodyQuiz>
                <Title text={"Date of birth"} startQuiz={startQuiz} />
                <BoxContent gap={32}>
                  <div className={"drop-wrapper"}>
                    <div className={"select-group"}>
                      <SelectGlobal
                        dateArray={getMonths()}
                        data={data?.month}
                        handleChange={handleAddMonth}
                        customClass={"month"}
                        label={"Month"}
                        errorBirthday={errorBirthday}
                      />
                      <SelectGlobal
                        dateArray={getDate()}
                        data={data?.day}
                        handleChange={handleAddDay}
                        customClass={"day"}
                        label={"Day"}
                        errorBirthday={errorBirthday}
                      />
                      <SelectGlobal
                        dateArray={getYears()}
                        data={data?.year}
                        handleChange={handleAddYear}
                        customClass={"year"}
                        label={"Year"}
                        errorBirthday={errorBirthday}
                      />
                    </div>
                    <div className={"birthday_confirm"}>
                      By proceeding you confirm that you are fully legally
                      capable of using website and major or at least 18 years
                      old
                    </div>
                    {errorBirthday && <ErrorField text={errorBirthday} />}
                  </div>

                  <Button
                    text={"Continue"}
                    classname={"btn btn--primary"}
                    onClick={handleChangeBirthday}
                  />
                </BoxContent>
              </BodyQuiz>
            </Popup>
          )}
          {step === 13 && (
            <>
              {loader && (
                <LoaderEmail
                  textMain={loaderTextMain}
                  textSub={loaderTextSub}
                />
              )}
              <Popup startQuiz={startQuiz} classname={"inner-gap"}>
                <BodyQuiz>
                  <Title
                    text={"Enter your real email address"}
                    startQuiz={startQuiz}
                  />
                  <BoxContent gap={32}>
                    <CheckboxContainer className={"mail"}>
                      <Label forId={"email"}>
                        <p>Your email</p>
                        <Input
                          typeInput={"text"}
                          onChange={handleChangeEmail}
                          placeholder={"Enter your real email address"}
                          value={data.email ? data.email : ""}
                          autoComplete="email"
                          name="email"
                          error={errorEmail}
                          onFocus={() => {
                            setShowTooltip(true);
                            simplyClick("cl_lnd_cd4_email_type_email", null);
                          }}
                          onBlur={() => setShowTooltip(false)}
                        />
                        {errorEmail && <ErrorField text={errorEmail} />}
                        {errorEmail === ERROR_EMAIL_ALREADY_USED && (
                          <div className="extra-info">
                            <p>
                              <a
                                href={`/login/?landing_id=${landingId}${
                                  data?.email
                                    ? `&email=${encodeURIComponent(data.email)}`
                                    : ""
                                }`}
                                onClick={() =>
                                  simplyClick("cl_lnd_cd4_againemail_login")
                                }
                              >
                                Log in{" "}
                              </a>
                              or use a different one.
                            </p>
                          </div>
                        )}
                        <Tooltip
                          text="We'll use this email for account verification and important notifications."
                          showTooltip={showTooltip}
                          className="email"
                        />
                      </Label>
                      {IS_VISIBLE_CUSTOM_AUTOCOMPLETE && (
                        <CustomEmailAutoComplete
                          errorEmail={errorEmail}
                          errorCb={() => setErrorEmail(null)}
                        />
                      )}
                    </CheckboxContainer>

                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={handlerSubmitEmail}
                    />
                  </BoxContent>
                </BodyQuiz>
              </Popup>
            </>
          )}
          {step === 14 && (
            <>
              {loader && (
                <div className="spin-loader">
                  <span>Loading...</span>
                </div>
              )}
              <Popup startQuiz={startQuiz} classname={"popup-password"}>
                <BodyQuiz>
                  <Title text={"Enter your password"} startQuiz={startQuiz} />
                  <BoxContent gap={40}>
                    <CheckboxContainer className={"mail"}>
                      <Label forId={"password"}>
                        <p>Your password</p>
                        <Input
                          typeInput={"password"}
                          onClick={isViewPassword}
                          placeholder={"Enter your password"}
                          onChange={handlerChangePassword}
                          pas={password}
                          error={errorPassword}
                          value={data.password || ""}
                          name="password"
                          autoComplete="password"
                          onFocus={() => {
                            setShowTooltip(true);
                            simplyClick(
                              "cl_lnd_cd4_password_type_password",
                              null
                            );
                          }}
                          onBlur={() => setShowTooltip(false)}
                        />
                        {errorPassword && <ErrorField text={errorPassword} />}
                        {responseError && <ErrorField text={responseError} />}
                        <Tooltip
                          text="Passwords must be at least 5 characters long. You can recover passwords at any time using the email address you provided."
                          showTooltip={showTooltip}
                        />
                      </Label>
                    </CheckboxContainer>
                    <CheckboxContainer className={"password"}>
                      <Label forId={"password-label"}>
                        <Checkbox
                          id={"password-label"}
                          errorCheckbox={errorCheckbox}
                          checked={x}
                          onChange={soldCheckbox}
                        />
                        <div className={"terms__wrap-block"}>
                          I have read, understand and agree to&nbsp;
                          <span>
                            <a href={`/terms-of-use${lndId}`} target="_blank">
                              Terms of Use,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href={`/privacy-policy${lndId}`} target="_blank">
                              Privacy Policy,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href={`/cookie-policy${lndId}`} target="_blank">
                              Cookie Policy,&nbsp;
                            </a>
                          </span>
                          <span>
                            <a href={`/billing-policy${lndId}`} target="_blank">
                              Billing&nbsp;
                            </a>
                          </span>
                          &&nbsp;
                          <span>
                            <a href={`/refund-policy${lndId}`} target="_blank">
                              Refund Policy,
                            </a>
                          </span>
                          &nbsp;
                          <span>
                            <a href={`/consent-policy${lndId}`} target="_blank">
                              Consent Policy
                            </a>
                          </span>
                        </div>
                      </Label>
                      {errorCheckbox && (
                        <ErrorField
                          text={
                            "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy"
                          }
                        />
                      )}
                    </CheckboxContainer>
                    <Button
                      text={"Continue"}
                      classname={"btn btn--primary"}
                      onClick={postRegistrationRequest}
                    />
                  </BoxContent>
                </BodyQuiz>
              </Popup>
            </>
          )}
        </div>
        {!startQuiz && <Footer cookiesNotView={cookiesState} />}
      </Layout>
      <div
        className={cn("site-footer-wrapper", { cookiesNotView: cookiesState })}
      >
        <Cookies
          cookiesClick={cookiesHandler}
          startQuiz={startQuiz}
          cookiesNotView={cookiesState}
        />
        <FooterMenu />
      </div>
    </div>
  );
};

export default App;
